export default {

	init() {
		// JavaScript to be fired on the about us page
		$(document).on('click', '.blog__load-more', (e) => {

			e.preventDefault();

			let offset = parseInt( $('.blog__load-more').data('offset') );

			//console.log(offset);

			$('.blog__load-more').addClass('loading');

			$.ajax({
				type: 'POST',
				dataType: 'json',
				url: siteOptions.ajaxurl,
				data: {
					action: 'bc_get_more_posts',
					offset: offset,
					nonce: siteOptions.nonce,
				},
				success: function (data) {
					if ( data['count'] < 6 ) {
						$('.blog__load-more').hide();
					}
					$('.blog__row').append(data['posts']);
					$('.blog__load-more').removeClass('loading');
					$('.blog__load-more').data('offset', offset + 6);

				},
			});

		});

	},

};


// WEBPACK FOOTER //
// ./scripts/routes/blog.js